import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Divider, Grid, Icon, IconButton, Modal, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { format } from "date-fns";
import { useState } from "react";
import { ToastContent } from "../../../../shared/components";
import { LoadingComp } from "../../../../shared/components/loading/Loading";
import { useToast } from "../../../../shared/hooks";
import { ProvisionService } from "../../../../shared/services/api/provisoes/ProvisionService";

interface Props {
	open: boolean;
	borderoId: string;
	onClose: () => void;
	onSuccess: () => void;
}

// Agendar (item 16, GARV2-1463/1464) — pede a data em que o lançamento no banco está programado,
// pra ficar salva e aparecer na tabela (não é só um marcador de status, precisamos saber "agendado
// pra quando"). Só o Financeiro aciona.
export const ModalScheduleBordero = ({ open, borderoId, onClose, onSuccess }: Props) => {
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down("sm"));
	const toastHandler = useToast();
	const [scheduledDate, setScheduledDate] = useState(format(new Date(), "yyyy-MM-dd"));
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");

	const handleConfirm = async () => {
		if (!scheduledDate) {
			setError("Informe a data agendada.");
			return;
		}
		setError("");

		setIsLoading(true);
		const result = await ProvisionService.borderoSchedule(borderoId, { origin: "financeiro", scheduledDate: `${scheduledDate} 12:00:00` });
		setIsLoading(false);

		if (result instanceof Error) {
			toastHandler.present({ type: "error", position: "top-right", messageOrContent: <ToastContent title="Erro" content={result.message} /> });
			return;
		}

		toastHandler.present({
			type: "success",
			position: "top-right",
			messageOrContent: <ToastContent title="Sucesso" content="Borderô agendado." />,
		});
		onSuccess();
		onClose();
	};

	return (
		<Modal open={open} onClose={onClose}>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					bgcolor: "background.paper",
					boxShadow: 24,
					p: 4,
					width: "95%",
					maxWidth: 560,
					borderRadius: 3,
				}}
			>
				<LoadingComp isopen={isLoading} />

				<Grid container justifyContent="space-between" alignItems="center">
					<Typography variant="h5" sx={{ color: "primary.main", fontWeight: 300 }}>
						Agendar Borderô
					</Typography>
					<IconButton onClick={onClose} size="small">
						<CloseIcon />
					</IconButton>
				</Grid>

				<Divider sx={{ my: 2 }} />

				<TextField
					fullWidth
					label="Data agendada"
					type="date"
					InputLabelProps={{ shrink: true, required: true }}
					value={scheduledDate}
					onChange={(e) => setScheduledDate(e.target.value)}
					error={Boolean(error)}
					helperText={error}
				/>

				<Grid container justifyContent="flex-end" flexDirection={smDown ? "column" : "row"} gap={2} mt={3}>
					<Button color="inherit" variant="contained" startIcon={<Icon>arrow_back</Icon>} onClick={onClose} sx={{ minWidth: 140 }}>
						Voltar
					</Button>
					<Button color="primary" variant="contained" startIcon={<Icon>event_available</Icon>} onClick={handleConfirm} sx={{ minWidth: 140 }}>
						Agendar
					</Button>
				</Grid>
			</Box>
		</Modal>
	);
};
